









import { AngularAlexMap } from '@/angular/angular-alex-map';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { EventBus } from '@/utils/EventBus';
import { Config } from '@/utils/Config';
import Map from '@/components/Map.vue';
import Contacts from '@/components/Contacts.vue';
import '@/assets/alex.min';
import { appName } from '@/angular/angular-alex-map';

@Component({
  components: {
    Map,
    Contacts
  }
})

export default class App extends Vue {
  @Prop() startType!: string;
  mounted(): void {
    AngularAlexMap.createAngularApp();
    EventBus.$emit(Config.MapShowVoOrSboLayerEvent, true);

    window.angular.element(() => {
        window.angular.bootstrap(document, [appName]);
    });
  }
}
